import { render, staticRenderFns } from "./CandidateList.vue?vue&type=template&id=67d11ac8&scoped=true&"
import script from "./CandidateList.vue?vue&type=script&lang=js&"
export * from "./CandidateList.vue?vue&type=script&lang=js&"
import style0 from "./CandidateList.vue?vue&type=style&index=0&id=67d11ac8&lang=scss&scoped=true&"
import style1 from "./CandidateList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d11ac8",
  null
  
)

export default component.exports